<img
  *ngFor="let thumbnail of thumbnails"
  class="thumbnail"
  [src]="thumbnail.src"
  [style.width.px]="thumbnail.width * scale"
  [style.height.px]="thumbnail.height * scale"
  (error)="hideMissingImage($event)"
/>
<div *ngIf="thumbnails.length === 0">No tracks found during this shift</div>
